module.exports = {"id":"201533","name":"Paul-Georges Ntep","rating":"77","photo":"./data/images/photos/4/201533.png","club":{"name":"ASSE","logo":"./data/images/clubs/ASSE.png"},"positions":["MG","AG","BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Paul-GeorgesNtep0.json
// module id = 3387
// module chunks = 0